import { render, staticRenderFns } from "./AdmissionExaminationRoom.vue?vue&type=template&id=a08881b0&"
import script from "./AdmissionExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./AdmissionExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionExaminationRoom.vue?vue&type=style&index=0&id=a08881b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports